var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator, } from "@/components/ui/Breadcrumb";
import { cn } from "@/lib/utils";
import { HomeIcon, SlashIcon } from "lucide-react";
function BreadcrumbContent(_a) {
    var item = _a.item, index = _a.index, isLastItem = _a.isLastItem;
    return isLastItem || !!(item === null || item === void 0 ? void 0 : item.current) ? (_jsx(BreadcrumbPage, __assign({ className: cn(!!(item === null || item === void 0 ? void 0 : item.current) && "font-bold", "text-gray-500", "pr-2") }, { children: item.name }))) : (_jsxs(BreadcrumbLink, __assign({ href: item.path, className: cn("flex items-center gap-2 py-2", index === 0 && "pl-2", isLastItem && "pr-2", !!(item === null || item === void 0 ? void 0 : item.current) && "font-bold") }, { children: [index === 0 && _jsx(HomeIcon, { className: "w-4 h-4 stroke-2" }), item.name] })));
}
export function Breadcrumbs(_a) {
    var pages = _a.pages;
    var lastBreadcrumbItem = pages.length - 1;
    return (_jsx(Breadcrumb, __assign({ className: "self-start -ml-4 mt-6 px-4 lg:self-auto lg:-ml-8 lg:w-[856px] md:pl-4" }, { children: _jsx(BreadcrumbList, __assign({ className: cn("w-fit text-xs bg-[#F4F5F780] font-[#7F7D7D] rounded-[8px]", "sm:text-sm") }, { children: pages.map(function (item, idx) { return (_jsxs(BreadcrumbItem, { children: [_jsx(BreadcrumbContent, { index: idx, item: item, isLastItem: lastBreadcrumbItem === idx }), lastBreadcrumbItem !== idx && (_jsx(BreadcrumbSeparator, { children: _jsx(SlashIcon, {}) }))] }, item.path)); }) })) })));
}
